(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cto-shipping-message"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cto-shipping-message')) {
    customElements.define('cto-shipping-message', class extends HTMLElement {
      connectedCallback() {
        this.updateMessage();
        this.onLoad = () => this.updateMessage();
        window.addEventListener('load', this.onLoad, { once: true });
      }
      disconnectedCallback() { window.removeEventListener('load', this.onLoad); }
      updateMessage() {
        const d = this.dataset;
        const international = d.international === 'true';
        const isCart = d.cartStatus === 'true';
        const currency = d.currency;
        let threshold = Number(d.threshold);
        let formatter;
        try { formatter = new Intl.NumberFormat(d.locale || 'en', { style: 'currency', currency, currencyDisplay: 'code' }); } catch (_) { return; }
        if (international) {
          const context = window.Shopify && window.Shopify.currency;
          const rate = Number(context && context.rate);
          if (d.storeCurrency !== 'CAD' || !context || context.active !== currency || !Number.isFinite(rate) || rate <= 0) return;
          const digits = formatter.resolvedOptions().maximumFractionDigits;
          const factor = Math.pow(10, digits);
          threshold = Math.ceil(300 * rate * factor - 1e-8) / factor * 100;
        }
        const title = this.querySelector('[data-shipping-title]');
        if (!title || !Number.isFinite(threshold) || threshold <= 0) return;
        if (!international && d.eligible !== 'true') return;
        const amount = formatter.format(threshold / 100);
        title.textContent = d.from.replace('[amount]', (international ? '≈ ' : '') + amount);
        if (!isCart || d.eligible !== 'true') return;
        const total = Math.max(0, Number(d.total) || 0);
        const remaining = Math.max(0, threshold - total);
        title.textContent = remaining === 0 ? d.reached : d.remaining.replace('[amount]', (international ? '≈ ' : '') + formatter.format(remaining / 100));
        const track = this.querySelector('[data-shipping-track]');
        const fill = this.querySelector('[data-shipping-fill]');
        if (track && fill) { track.hidden = false; fill.style.width = Math.min(100, total / threshold * 100) + '%'; }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
